import { Card } from "@/components/ui/card";
import { Wand2, Construction } from "lucide-react";

export const ReputationAIPage = () => {
  return (
    <div className="space-y-6" data-testid="reputation-ai-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>
          Reputation — AI Content Generator
        </h1>
        <p className="text-slate-500 mt-1">
          GPT-5.2 powered SEO block generation for the FakeReviewRemovalPro.com pages.
        </p>
      </div>
      <Card className="p-10 text-center" data-testid="ai-coming-soon">
        <Construction className="w-12 h-12 text-orange-500 mx-auto mb-4" />
        <h2 className="text-xl font-semibold mb-2 flex items-center justify-center gap-2">
          <Wand2 className="w-5 h-5" /> Coming in Étape 3
        </h2>
        <p className="text-slate-600 max-w-xl mx-auto">
          This screen will let you generate AI blocks for homepage, services, review types, industries
          and the Case Builder, using your OpenAI key — same pipeline pattern as A-Star's GEO module.
        </p>
      </Card>
    </div>
  );
};

export default ReputationAIPage;
